export const RU_MOBILE_MASK = '+7 (D99) 999-99-99';
export const RU_MOBILE_FORMAT_CHARS = { D: '[9]', 9: '[0-9]' };
export const RU_MOBILE_REGEX = /^\+7\s\(9\d{2}\)\s\d{3}-\d{2}-\d{2}$/;

function digitsOnly(v) {
  return String(v ?? '').replace(/\D/g, '');
}

/**
 * Нормализует ввод к формату хранения `79XXXXXXXXX`.
 * Возвращает null, если номер пустой/некорректный/не мобильный РФ.
 */
export function normalizeRuMobilePhone(v) {
  const digits = digitsOnly(v);
  if (!digits) return null;

  let d = digits;
  if (d.length === 10) d = `7${d}`;
  else if (d.length === 11 && d.startsWith('8')) d = `7${d.slice(1)}`;

  if (!/^79\d{9}$/.test(d)) return null;
  return d;
}

/**
 * Формат отображения: `+7 (9xx) xxx-xx-xx`.
 * При неполном/невалидном номере возвращает исходное значение.
 */
export function formatRuMobilePhone(v) {
  const n = normalizeRuMobilePhone(v);
  if (!n) return String(v ?? '');
  const p = n.slice(1); // 10 цифр после кода страны
  return `+7 (${p.slice(0, 3)}) ${p.slice(3, 6)}-${p.slice(6, 8)}-${p.slice(8, 10)}`;
}

export function isCompleteRuMobileMask(v) {
  return RU_MOBILE_REGEX.test(String(v ?? ''));
}
